module.exports = __webpack_public_path__ + "static/media/ico_mundo_pride.f42dbd3a.png";